<template>
	<el-card class="el-card">
		<div class="time_table">
			<el-select v-model="project" placeholder="适用项目" @change="changeProject">
				<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"> </el-option>
			</el-select>
		</div>

		<div class="table">
			<el-table
				:data="tableData"
				style="width: 100%"
				:header-cell-style="{ background: '#eef1f6' }"
				v-loading="loading"
			>
				<el-table-column prop="name" label="优惠券名称"> </el-table-column>
				<el-table-column align="center" label="券面金额">
					<template slot-scope="scope">{{ scope.row.couponAmount }} 元</template>
				</el-table-column>
				<el-table-column prop="category" align="center" label="适用项目"> </el-table-column>
				<el-table-column prop="thirdNo" align="center" label="有效日期">
					<template slot-scope="scope"
						>{{ scope.row.effectiveStart }} - {{ scope.row.effectiveEnd }}</template
					>
				</el-table-column>
			</el-table>
		</div>
		<div class="toolbar large-list">
			<div class="pagination-group">
				<el-pagination
					:background="true"
					:page-sizes="[30, 50, 100]"
					:page-size.sync="pageSize"
					:current-page.sync="page"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
					@size-change="getCoupon"
					@current-change="getCoupon"
				/>
			</div>
		</div>
	</el-card>
</template>

<script>
import { modules, Coupon } from '@/utils/api'

export default {
	data() {
		return {
			loading: false,
			tableData: [],
			pageSize: 30,
			page: 1,
			total: 0,
			status: [],
			options: [],
			project: 0,
		}
	},
	mounted() {
		this.reqmodules()
		this.getCoupon()
	},
	methods: {
		//模块列表
		reqmodules() {
			modules().then((res) => {
				res.unshift({ id: 0, name: '全部适用项目' })
				this.options = res
			})
		},
		//优惠券列表
		getCoupon() {
			let params = {
				moduleId: this.project,
				page: this.page,
				perPage: this.pageSize,
				scene: 1,
			}
			Coupon(params).then((res) => {
				this.tableData = res.data
				this.total = res.total
			})
		},
		//选择项目
		changeProject() {
			this.page = 1
			this.getCoupon()
		},
	},
}
</script>

<style scoped>
.el-card {
	padding-bottom: 52px;
	position: relative;
}
.table {
	padding-bottom: 60px;
}
.el-table__header-wrapper {
	height: 30px;
}
.condition {
	font-weight: bold;
}
.condition_i {
	vertical-align: middle;
	width: 16px;
	display: inline-block;
	cursor: pointer;
}
.toolbar {
	text-align: right;
	padding: 10px 10%;
	height: 32px;
	width: 80%;
	background-color: #fff;
}
.large-list {
	position: fixed;
	right: 37px;
	bottom: 0;
}
.status {
	width: 5px;
	height: 5px;
	border-radius: 50%;
	display: inline-block;
	vertical-align: middle;
	margin-right: 2px;
}
.notstart {
	background-color: #ccc;
}
.executed {
	background-color: #52c41a;
}
.effect {
	background-color: #1890ff;
}
.failed {
	background-color: #ff4d4f;
}
.statusText {
	vertical-align: middle;
}

.time_table {
	margin-bottom: 20px;
}
</style>
